/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedStarterPacksSkeleton.defs'
export { main as default } from './getSuggestedStarterPacksSkeleton.defs'
